// 待办中心
const TodoList = resolve => require(['@/views/TodoCenter/TodoList'], resolve)
// 报价
const QuoteDetail = resolve =>
  require(['@/views/TodoCenter/QuoteDetail'], resolve)
const JobNumberList = resolve =>
  require(['@/views/TodoCenter/JobNumberList'], resolve)
const JobNumberDetail = resolve =>
  require(['@/views/TodoCenter/JobNumberDetail'], resolve)
const MaterialsBillList = resolve =>
  require(['@/views/TodoCenter/MaterialsBillList'], resolve)
const QuoExppartList = resolve =>
  require(['@/views/TodoCenter/QuoExppartList'], resolve)
const MaterialsBillDetail = resolve =>
  require(['@/views/TodoCenter/MaterialsBillDetail'], resolve)
const ProjectList = resolve =>
  require(['@/views/TodoCenter/ProjectList'], resolve)
const ProjectDetail = resolve =>
  require(['@/views/TodoCenter/ProjectDetail'], resolve)
const OtherPaymentsList = resolve =>
  require(['@/views/TodoCenter/OtherPaymentsList'], resolve)
const OtherPaymentsDetail = resolve =>
  require(['@/views/TodoCenter/OtherPaymentsDetail'], resolve)
const PaymentPercentList = resolve =>
  require(['@/views/TodoCenter/PaymentPercentList'], resolve)
const PaymentPercentDetail = resolve =>
  require(['@/views/TodoCenter/PaymentPercentDetail'], resolve)
const ApproveDetail = resolve =>
  require(['@/views/Approve/TbjApprove/ApproveDetail'], resolve)
const refresh = resolve =>
  require(['@/views/Approve/TbjApprove/refresh'], resolve)
const FeeincDetail = resolve =>
  require(['@/views/Approve/FeeincApprove/FeeincDetail'], resolve)
const engineeProvider = resolve =>
  require(['@/views/TodoCenter/engineeProviderDetail'], resolve)
const paymentList = resolve => require(['@/views/payment/paymentList'], resolve)
const paymentDetail = resolve =>
  require(['@/views/payment/paymentDetail'], resolve)
const creditInvestigationApproval = resolve =>
  require(['@/views/TodoCenter/creditInvestigationApprovalDetail'], resolve)
const financeApproval = resolve =>
  require(['@/views/TodoCenter/financeApprovalDetail'], resolve)
const advanceInvoicingApproval = resolve =>
  require(['@/views/TodoCenter/advanceInvoicingApprovalDetail'], resolve)
const exceedWarrantyApproval = resolve =>
  require(['@/views/TodoCenter/exceedWarrantyApprovalDetail'], resolve)
const exceedDeliveryApproval = resolve =>
  require(['@/views/TodoCenter/exceedDeliveryApprovalDetail'], resolve)
const crossRegionApproval = resolve =>
  require(['@/views/TodoCenter/crossRegionApprovalDetail'], resolve)
const cancelladderApproval = resolve =>
  require(['@/views/ContractApply/cancelladderApproval'], resolve)
const AdvancesealApproval = resolve =>
  require(['@/views/ContractApply/AdvancesealApproval'], resolve)
const contractAuthorizationDetail = resolve =>
  require(['@/views/Approve/AdvanceApprove/contractAuthorization'], resolve)
const aheadScheduleDetail = resolve =>
  require(['@/views/Approve/AdvanceApprove/aheadSchedule'], resolve)
const reliefRentDetail = resolve =>
  require(['@/views/Approve/AdvanceApprove/reliefRent'], resolve)
const openFLowApproveDetail = resolve =>
  require(['@/views/Approve/AdvanceApprove/openFLowApprove'], resolve)
const materialAgreementApproveDetail = resolve =>
  require(['@/views/Approve/MaterialApprove/materialAgreementApprove'], resolve)
const materialAgreementApproveChangeDetail = resolve =>
  require([
    '@/views/Approve/MaterialApprove/materialAgreementApproveChange',
  ], resolve)
const letterguaranteeApproval = resolve =>
  require(['@/views/ContractApply/LetterOfGuaranteesApproval'], resolve)
const specialprice = resolve =>
  require(['@/views/TodoCenter/SpecialPriceDetail'], resolve)
const distributioncertificate = resolve =>
  require(['@/views/TodoCenter/DistributionDetail'], resolve)
const TenderDetail = resolve =>
  require(['@/views/TodoCenter/TenderDetail'], resolve)
const CertificateDetail = resolve =>
  require(['@/views/TodoCenter/CertificateDetail'], resolve)
const priceAdjustmentApprovalDetail = resolve =>
  require(['@/views/TodoCenter/priceAdjustmentApprovalDetail'], resolve)
const bidApproval = resolve =>
  require(['@/views/TodoCenter/bidApprovalDetail'], resolve)
export default [
  {
    name: 'Todo_list',
    path: '/todoCenter/todoList',
    component: TodoList,
    meta: {
      keepAlive: false,
      title: '待办列表',
    },
  },
  {
    name: 'Quote_detail',
    path: '/todoCenter/quote/detail',
    component: QuoteDetail,
    meta: {
      keepAlive: false,
      title: '报价详情',
    },
  },
  {
    name: 'Approve_detail',
    path: '/todoCenter/quote/ApproveDetail',
    component: ApproveDetail,
    meta: {
      keepAlive: false,
      title: '审批详情',
    },
  },
  {
    name: 'refresh',
    path: '/todoCenter/quote/tbjDetail',
    component: refresh,
    meta: {
      keepAlive: false,
      title: '审批详情',
    },
  },
  {
    name: 'Feeinc_detail',
    path: '/todoCenter/quote/FeeIncDetail',
    component: FeeincDetail,
    meta: {
      keepAlive: false,
      title: '审批详情',
    },
  },
  {
    name: 'QuoteJobNumber_list',
    path: '/todoCenter/quote/detail/jobNumberList',
    component: JobNumberList,
    meta: {
      keepAlive: false,
      title: '工号信息列表',
    },
  },
  {
    name: 'QuoteJobNumber_detail',
    path: '/todoCenter/quote/detail/jobNumberList/jobNumberDetail',
    component: JobNumberDetail,
    meta: {
      keepAlive: false,
      title: '工号行详情',
    },
  },
  {
    name: 'QuoExppart_list',
    path: '/todoCenter/quote/detail/QuoExppartList',
    component: QuoExppartList,
    meta: {
      keepAlive: false,
      title: '报价条款列表',
    },
  },
  {
    name: 'MaterialsBill_list',
    path: '/todoCenter/quote/detail/materialsBillList',
    component: MaterialsBillList,
    meta: {
      keepAlive: false,
      title: '物料清单列表',
    },
  },
  {
    name: 'MaterialsBill_detail',
    path: '/todoCenter/quote/detail/materialsBillList/materialsBillDetail',
    component: MaterialsBillDetail,
    meta: {
      keepAlive: false,
      title: '物料清单详情',
    },
  },
  {
    name: 'Project_list',
    path: '/todoCenter/quote/detail/projectList',
    component: ProjectList,
    meta: {
      keepAlive: false,
      title: '项目行列表',
    },
  },
  {
    name: 'Project_detail',
    path: '/todoCenter/quote/detail/projectList/projectDetail',
    component: ProjectDetail,
    meta: {
      keepAlive: false,
      title: '项目行详情',
    },
  },
  {
    name: 'OtherPayments_list',
    path: '/todoCenter/quote/detail/otherPaymentsList',
    component: OtherPaymentsList,
    meta: {
      keepAlive: false,
      title: '其他款项列表',
    },
  },
  {
    name: 'OtherPayments_detail',
    path: '/todoCenter/quote/detail/otherPaymentsList/otherPaymentsDetail',
    component: OtherPaymentsDetail,
    meta: {
      keepAlive: false,
      title: '其他款项详情',
    },
  },
  {
    name: 'PaymentPercent_list',
    path: '/todoCenter/quote/detail/paymentPercentList',
    component: PaymentPercentList,
    meta: {
      keepAlive: false,
      title: '付款比例列表',
    },
  },
  {
    name: 'PaymentPercent_detail',
    path: '/todoCenter/quote/detail/paymentPercentList/paymentPercentDetail',
    component: PaymentPercentDetail,
    meta: {
      keepAlive: false,
      title: '付款比例详情',
    },
  },
  {
    name: 'engineeProvider_detail',
    path: '/todoCenter/contract/detail/engineeProviderDetail',
    component: engineeProvider,
    meta: {
      keepAlive: false,
      title: '工程服务商申请详情',
    },
  },
  {
    name: 'creditInvestigationApproval_detail',
    path: '/todoCenter/contract/detail/creditInvestigationApprovalDetail',
    component: creditInvestigationApproval,
    meta: {
      keepAlive: false,
      title: '免信用调查申请详情',
    },
  },
  {
    name: 'financeApproval_detail',
    path: '/todoCenter/contract/detail/financeApprovalDetail',
    component: financeApproval,
    meta: {
      keepAlive: false,
      title: '财务类审批详情',
    },
  },
  {
    name: 'advanceInvoicingApproval_detail',
    path: '/todoCenter/contract/detail/advanceInvoicingApprovalDetail',
    component: advanceInvoicingApproval,
    meta: {
      keepAlive: false,
      title: '发票条款申请（提前开票）详情',
    },
  },
  {
    name: 'exceedWarrantyApproval_detail',
    path: '/todoCenter/contract/detail/exceedWarrantyApprovalDetail',
    component: exceedWarrantyApproval,
    meta: {
      keepAlive: false,
      title: '质保期超标准申请',
    },
  },
  {
    name: 'exceedDeliveryApproval_detail',
    path: '/todoCenter/contract/detail/exceedDeliveryApprovalDetail',
    component: exceedDeliveryApproval,
    meta: {
      keepAlive: false,
      title: '交货期不满足条款申请',
    },
  },
  {
    name: 'crossRegionApproval_detail',
    path: '/todoCenter/contract/detail/crossRegionApprovalDetail',
    component: crossRegionApproval,
    meta: {
      keepAlive: false,
      title: '跨区域项目审批',
    },
  },
  {
    name: 'payment_list',
    path: '/todoCenter/contract/detail/paymentlist',
    component: paymentList,
    meta: {
      keepAlive: false,
      title: '付款方式列表',
    },
  },
  {
    name: 'paymentDetail',
    path: '/todoCenter/contract/detail/paymentlist/detail',
    component: paymentDetail,
    meta: {
      keepAlive: false,
      title: '付款方式详情',
    },
  },
  {
    name: 'contractAuthorization_detail',
    path: '/todoCenter/advance/contractAuthorization',
    component: contractAuthorizationDetail,
    meta: {
      keepAlive: false,
      title: '欠款发货审批',
    },
  },
  {
    name: 'aheadSchedule_detail',
    path: '/todoCenter/advance/aheadSchedule',
    component: aheadScheduleDetail,
    meta: {
      keepAlive: false,
      title: '提前排产审批',
    },
  },
  {
    name: 'reliefRent_detail',
    path: '/todoCenter/advance/reliefRent',
    component: reliefRentDetail,
    meta: {
      keepAlive: false,
      title: '减免仓租审批',
    },
  },
  {
    name: 'openFLowApprove_detail',
    path: '/todoCenter/advance/openFLowApprove',
    component: openFLowApproveDetail,
    meta: {
      keepAlive: false,
      title: '开放流程审批',
    },
  },
  {
    name: 'cancelladder_approval',
    path: '/todoCenter/contract/cancelladderApproval',
    component: cancelladderApproval,
    meta: {
      keepAlive: false,
      title: '撤梯申请',
    },
  },
  {
    name: 'advanceseal_approval',
    path: '/todoCenter/contract/AdvancesealApproval',
    component: AdvancesealApproval,
    meta: {
      keepAlive: false,
      title: '提前盖章审批',
    },
  },
  {
    name: 'materialAgreementApprove_detail',
    path: '/todoCenter/material/materialAgreementApprove',
    component: materialAgreementApproveDetail,
    meta: {
      keepAlive: false,
      title: '配件协议审批',
    },
  },
  {
    name: 'materialAgreementApproveChange_detail',
    path: '/todoCenter/material/materialAgreementApproveChange',
    component: materialAgreementApproveChangeDetail,
    meta: {
      keepAlive: false,
      title: '配件协议变更单审批',
    },
  },
  {
    name: 'cancelladder_approval',
    path: '/todoCenter/contract/cancelladderApproval',
    component: cancelladderApproval,
    meta: {
      keepAlive: false,
      title: '撤梯申请',
    },
  },
  {
    name: 'specialprice',
    path: '/todoCenter/opportunity/specialpriceApproval',
    component: specialprice,
    meta: {
      keepAlive: false,
      title: '特殊价格申请单',
    },
  },
  {
    name: 'letterguarantee_approval',
    path: '/todoCenter/contract/letterguaranteeApproval',
    component: letterguaranteeApproval,
    meta: {
      keepAlive: false,
      title: '保函申请',
    },
  },
  {
    name: 'distributioncertificate',
    path: '/todoCenter/opportunity/distributioncertificate',
    component: distributioncertificate,
    meta: {
      keepAlive: false,
      title: '单项经销证明申请',
    },
  },
  {
    name: 'Tender_detail',
    path: '/todoCenter/opportunity/Tender_detail',
    component: TenderDetail,
    meta: {
      keepAlive: false,
      title: '保证金申请单',
    },
  },
  {
    name: 'Certificate_detail',
    path: '/todoCenter/opportunity/Certificate_detail',
    component: CertificateDetail,
    meta: {
      keepAlive: false,
      title: '授权委托证明书',
    },
  },
  {
    name: 'priceAdjustmentApprovalDetail',
    path: '/todoCenter/detail/priceAdjustmentApproval_detail',
    component: priceAdjustmentApprovalDetail,
    meta: {
      keepAlive: false,
      title: '调验价格审批',
    },
  },
  {
    name: 'BidApproval_detail',
    path: '/todoCenter/contract/detail/bidApprovalDetail',
    component: bidApproval,
    meta: {
      keepAlive: false,
      title: '投标/报价项目',
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/todoCenter.js